import React from "react";
import useSettings from "stores/settings";
import { useRouter } from "next/router";
import LogOut from "components/LogOut";
import * as jwt from "jsonwebtoken";
import ChangeUrlToken from "components/ChangeUrlToken";

export default function Home() {
  const settings = useSettings();
  const router = useRouter();

  /* 접속 시간 체크 */
  if (settings.login && settings.loginTime) {
    const tempLimitAccessTimeDate = new Date(settings.loginTime).getTime() + 20 * 60 * 1000;
    const nowDate = new Date().getTime();
    const tempAccessTime = Math.floor((Number(tempLimitAccessTimeDate) - Number(nowDate)) / 1000);

    /* 접속 시간이 만료되었을 경우 */
    if (tempAccessTime < 0) {
      Swal.fire({
        html: "<p class='text-white'>세션이 만료되어 로그아웃 되었습니다</p>",
        background: "#1F2937",
        showConfirmButton: false,
        timer: 3000,
      });
      LogOut(settings);
      router.push("/users/login");
    }
  }

  if (!settings.login) {
    // 로그인이 되어 있지 않으면 로그인 화면으로 이동
    if (typeof window !== "undefined") router.push("/users/login");
  } else {
    if (typeof window !== "undefined") {
      if (settings.isAdmin) {
        const tokenValue = window.localStorage.getItem("urlToken");
        if (tokenValue === "" || tokenValue === null) {
          ChangeUrlToken("/map");
          router.push("/map");
        } else {
          jwt.verify(tokenValue, process.env.SECRET_CODE, async (error, decoded) => {
            if (error) {
              ChangeUrlToken("/map");
              router.push("/map");
            } else {
              try {
                const { url } = decoded;
                router.push(url);
              } catch (e) {
                ChangeUrlToken("/map");
                router.push("/map");
              }
            }
          });
        }
      } else {
        const tokenValue = window.localStorage.getItem("urlToken");

        if (tokenValue === "" || tokenValue === null) {
          ChangeUrlToken("/dashboard/Generation");
          router.push("/dashboard/Generation");
        } else {
          jwt.verify(tokenValue, process.env.SECRET_CODE, async (error, decoded) => {
            if (error) {
              ChangeUrlToken("/dashboard/Generation");
              router.push("/dashboard/Generation");
            } else {
              try {
                const { url } = decoded;
                router.push(url);
              } catch (e) {
                ChangeUrlToken("/dashboard/Generation");
                router.push("/dashboard/Generation");
              }
            }
          });
        }
      }
    }
  }

  // 아래 코드는 실행 되지 않음
  return <div className="w-full h-full mx-auto text-center ">LOADING AQUA DASHBOARD...</div>;
}
